export enum ChannelId {
  Internal = 'internal',
  External = 'external',
  ACH = 'ach',
  Credit = 'credit',
  P2P = 'p2p',
  BillPay = 'billpay',
  CheckWithdrawal = 'withdrawal',
  Skip = 'skip',
  M2M = 'm2m',
  Investment = 'investment',
  StopCheck = 'stopcheck',
  Wire = 'wire',
  PayByCard = 'paybycard',
  Invoices = 'invoices',
}
